export default {
  dashboard: {
    auth: {
      token: '',
      loggedin: false,
    },
    adData: [
      {
        id: '0',
        type: 'published',
        attributes: {
          expiry: 0,
          category: 0,
          category_name: '',
          type: 's',
          subject: '',
          list_id: '0',
          view_count: {
            daily: '0',
            total: '0',
          },
          price: {
            name: 'price',
            value: '0',
          },
          minor_category: {
            name: '',
            value: '0',
            label: '',
          },
          visibility: {
            low: '',
            page: '',
            position: '',
          },
        },
        links: {
          edit: '',
          copy: '',
          self: '',
          image: '',
        },
        adService: {
          active_services: [],
          allowed_services: [],
          services_price: {
            bump: '',
            bump_daily: '',
            bump_14: '',
            urgent: '',
            gallery_ad_monthly: '',
            gallery_ad: '',
            highlight: '',
          },
          edit_action: {
            enabled: false,
            message: '',
          },
          republish_action: {
            enabled: false,
            message: '',
          },
          bulk_action: {
            select_enabled: false,
          },
        },
        adSelected: false,
        adChecked: {
          bump: false,
          bump7: false,
          bump14: false,
          urgent: false,
          featured7: false,
          featured30: false,
        },
      },
    ],
    multiPageList: [],
    cart: {
      credit: 0,
      services: [
        {
          id: 0,
          purchase: [
            {
              name: '',
              bucket_id: 0,
            },
          ],
        },
      ],
    },
    adMassChecked: false,
    batchPosting: {
      total: 0,
      current: 0,
    },
    totalPages: 0,
    adTotal: {
      published: 0,
      'low-vis': 0,
      draft: 0,
      pending: 0,
      deleted: 0,
      expired: 0,
      refused: 0,
    },
    adRowLoading: false,
    infoLoading: false,
    creditLoading: false,
    galleryLoading: true,
    storeUsersLoading: false,
    paymentResultLoading: false,
    listingReload: false,
    creditReload: false,
    unread_chat_msg_count: 0,
    currentTab: '',
    profile: {
      store_id: '',
      name: '',
      email: '',
      category: '',
      type: '',
      role: '',
      livechat: '',
      company: '',
      agent_number: '',
      agent_identity: '',
      since: '',
      verified: false,
      picture: '',
      logo: '',
      user_id: '',
      verified_allowed: false,
      verified_label: '',
      store_group: {
        enabled: '',
        value: '',
        upgrade_options: [],
      },
      store_region_special: '',
      store_subarea_special: '',
      store_network: {
        account_type: '',
        account_type_label: '',
        enabled: false,
        landing_page: '',
        parent_store_name: '',
        parent_store_email: '',
        parent_store_phone_number: '',
      },
      auto_top_up: {
        enabled: false,
        incentive_eligible: false,
        bonus_amount: 0,
      },
      eInvoice: {
        enabled: false,
      },
    },
    credit: {
      free_ads: '',
      voucher: {
        credits: '',
        expiry: '',
        label: '',
        alert: 0,
        alert_label: '',
      },
      promo: {
        credits: '',
        expiry: '',
        grace_period: '',
        label: '',
        alert: 0,
        alert_label: '',
      },
      buckets: [
        {
          bkt_id: 0,
          bkt_type: '',
          bkt_expiry: '',
          bkt_bal: 0,
          bkt_cat: [],
          bkt_cost_type: '',
        },
      ],
      credit_details: {
        edit: '',
      },
    },
    creditV2: {
      loading: false,
    },
    gamificationLoading: false,
    gamificationReload: false,
    gamification: {
      progress: 0,
      is_off: true,
      promo_credit: false,
      levels: [
        { locked: false, tips: '' },
        { locked: false, tips: '' },
        { locked: false, tips: '' },
      ],
      rules: [{ checked: false }, { checked: false }, { checked: false }],
    },
    credit_plans: [],
    credit_payment_methods: [],
    gallery: {
      images: [],
      uploading: false,
      upload_response: {},
    },
    store_users: {
      users: [],
      meta: {},
      messages: {},
    },
    credits_purchased_success: false,
    credits_purchased_error: null,
    credits_purchase: {},
    payment: {},
    galleryTotalPages: 0,
  },
};
